import styled from 'styled-components';

// Fundo do pop-up cobrindo a tela inteira
export const PopUpContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    background-color: ${props => props?.background_color ? `${props?.background_color}99` : "rgba(0, 0, 0, 0.7)"}; // Fundo semi-transparente
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 998;
`;

// Conteúdo principal do pop-up
export const PopUpContent = styled.div`
    background-color: #303030;
    color: #ffffff;
    border-radius: 12px;
    padding: 24px 32px;
    width: 90%;
    max-width: 400px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    font-family: Arial, sans-serif;
    
    h3 {
        font-size: 1.2rem;
        margin-bottom: 10px;
    }

    .episode {
        font-size: .9rem;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: 500;
    }

    @media (max-width: 600px) {

        padding: 30px 15px;
    
        h3 {
            font-size: 1rem;
            margin-bottom: 5px;
        }

        .episode {
            font-size: .75rem;
        }

    }
`;

// Contêiner para botões com espaçamento
export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: 20px;
`;

// Estilo dos botões
export const Button = styled.button`
    flex: 1;
    padding: 12px 0;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    
    &:first-child {
        background-color: #4CAF50; // Verde para o botão "Sim"
        color: white;
    }
    &:first-child:hover {
        background-color: #45a049;
    }

    &:last-child {
        background-color: #f44336; // Vermelho para o botão "Não"
        color: white;
    }
    &:last-child:hover {
        background-color: #e53935;
    }
`;

// Contêiner para o checkbox
export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 14px;
    color: #b0b0b0;
    
    input[type='checkbox'] {
        margin-right: 8px;
        cursor: pointer;
        transform: scale(1.2);
    }

    label {
        cursor: pointer;
        display: flex;
        align-items: center;
    }
`;
